import { render, staticRenderFns } from "./apartment-client-changes-deadlines.vue?vue&type=template&id=450f3514&scoped=true&"
import script from "./apartment-client-changes-deadlines.ts?vue&type=script&lang=ts&"
export * from "./apartment-client-changes-deadlines.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-client-changes-deadlines.scss?vue&type=style&index=0&id=450f3514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f3514",
  null
  
)

export default component.exports